import { ManagedUserGroup } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";

const IdpGroupMappingTableNameCell = ({
  item: group,
  ...cellProps
}: TableSimpleCellProps<ManagedUserGroup>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>{group.groupName}</TableCellText>
    </TableSimpleCell>
  );
};

export default IdpGroupMappingTableNameCell;
